import script from "./Motolino-Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Motolino-Settings.vue?vue&type=script&setup=true&lang=js"

import "./Motolino-Settings.vue?vue&type=style&index=0&id=47858e5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47858e5b"]])

export default __exports__